import { connect } from 'react-redux';
import { ExchangeMessage } from './ExchangeMessage';

const mapStateToProps = ({ miniCart }) => ({
  miniCart,
});

export default connect(mapStateToProps)(ExchangeMessage);
